module.exports = __webpack_public_path__ + "img/collection-button.95baef6d.png";